var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Approval Hierarchy")])])])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Approval Object "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approvalObject),
      expression: "approvalObject"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('approvalObject')
    },
    attrs: {
      "type": "radio",
      "id": "client",
      "value": "client",
      "name": "approvalObject"
    },
    domProps: {
      "checked": _vm._q(_vm.approvalObject, "client")
    },
    on: {
      "change": _vm.getApprovalHierarchyRole,
      "__c": function($event) {
        _vm.approvalObject = "client"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Client"
    }
  }, [_vm._v("Client ")]), _vm._v("     \n                    "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approvalObject),
      expression: "approvalObject"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('approvalObject')
    },
    attrs: {
      "type": "radio",
      "id": "contract",
      "value": "contract",
      "name": "approvalObject"
    },
    domProps: {
      "checked": _vm._q(_vm.approvalObject, "contract")
    },
    on: {
      "change": _vm.getApprovalHierarchyRole,
      "__c": function($event) {
        _vm.approvalObject = "contract"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Contract"
    }
  }, [_vm._v("Contract")]), _vm._v("     \n                    "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approvalObject),
      expression: "approvalObject"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('approvalObject')
    },
    attrs: {
      "type": "radio",
      "id": "rate",
      "value": "rate",
      "name": "approvalObject"
    },
    domProps: {
      "checked": _vm._q(_vm.approvalObject, "rate")
    },
    on: {
      "change": _vm.getApprovalHierarchyRole,
      "__c": function($event) {
        _vm.approvalObject = "rate"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Rate"
    }
  }, [_vm._v("Rate")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('approvalObject')),
      expression: "errors.has('approvalObject')"
    }],
    staticClass: "text-danger "
  }, [_vm._v("Please select approval object.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Approval Levels "), _c('span', {
    staticClass: "required"
  }, [_vm._v("* ")]), _vm._v("(From level 1 approval to final approval authority)")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center ",
    attrs: {
      "width": "5%"
    }
  }, [_c('b', [_vm._v("Level Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v("Role (Single Selection)")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "35%"
    }
  }, [_c('b', [_vm._v("User ID (Multi Selection)")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "5%"
    }
  }, [_c('b', [_vm._v("Send Email")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center ",
    attrs: {
      "width": "6%"
    }
  }, [_c('b', [_vm._v("#")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.approvelData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('b-input-group', {
      attrs: {
        "left": "<i class=\"fa fa-map-pin\"></i>"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.roleId),
        expression: "data.roleId"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "name": "role",
        "id": "role"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          data.roleId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getUserAgainRole(data.roleId, index)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Select Role")]), _vm._v(" "), _vm._l((_vm.rolesList), function(list) {
      return _c('option', {
        domProps: {
          "value": list.roleid
        }
      }, [_vm._v(_vm._s(list.rolename))])
    })], 2)]), _vm._v(" "), _c('span', {
      staticClass: "text-danger "
    }, [_vm._v(_vm._s(data.roleError))])], 1), _vm._v(" "), _c('td', [_c('b-input-group', {
      attrs: {
        "left": "<i class='fa fa-user'></i>"
      }
    }, [_c('multiselect', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "options": data.userList,
        "track-by": "value",
        "label": "text",
        "multiple": true,
        "placeholder": "Select User",
        "name": "user"
      },
      on: {
        "input": function($event) {
          _vm.removeUserError(data.userId, index)
        }
      },
      model: {
        value: (data.userId),
        callback: function($$v) {
          data.userId = $$v
        },
        expression: "data.userId"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "text-danger "
    }, [_vm._v(_vm._s(data.userError))])], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-md-4 checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em",
        "margin-left": "4px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.isSendEmail),
        expression: "data.isSendEmail"
      }],
      attrs: {
        "type": "checkbox",
        "id": "emailcheck"
      },
      domProps: {
        "checked": Array.isArray(data.isSendEmail) ? _vm._i(data.isSendEmail, null) > -1 : (data.isSendEmail)
      },
      on: {
        "__c": function($event) {
          var $$a = data.isSendEmail,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (data.isSendEmail = $$a.concat($$v))
            } else {
              $$i > -1 && (data.isSendEmail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            data.isSendEmail = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', [_vm._v("\n                                   "), (_vm.approvelData.length != 1) ? _c('i', {
      staticClass: "fa fa-trash fa-2x",
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteRow(index)
        }
      }
    }) : _vm._e(), _vm._v("  \n                                  "), ((index + 1) == _vm.approvelData.length) ? _c('i', {
      staticClass: "fa fa-plus-circle fa-2x",
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "title": "Add"
      },
      on: {
        "click": function($event) {
          _vm.addNewRow(index)
        }
      }
    }) : _vm._e()])])
  }))])])])]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  })], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24260f62","hasScoped":true}!./src/modules/masterdata/views/ApprovalHierarchy/approvalHierarchy/approvalHierarchy.component.html
// module id = 832
// module chunks = 3